import React from 'react';
import './App.css';
import Header from './Component/Header';
import About from './Component/About';
import Skills from './Component/Skills';
import Portfolio from './Component/Portfolio';
import Contact from './Component/Conract';
import MyInfo from './Component/MyInfo';

function App() {
  return (
    <div className="App">
      <Header />
      <About />
      <MyInfo />
      <Skills />
      <Portfolio />
      <Contact />
    </div>
  );
}

export default App;
